<template>
  <div class="restaurant-list">
    <div v-for="restaurant in restaurants" :key="restaurant.id" class="restaurant-list-item"
      @click="$emit('select', restaurant)">

      <div class="restaurant-item-image">
        <img v-if="restaurant.imageUrl" :src="restaurant.imageUrl" :alt="restaurant.companyName || restaurant.displayName"/>
        <img v-else :src="shopIcon" :alt="restaurant.companyName || restaurant.displayName" class="shop-placeholder-icon"/>
      </div>

      <div class="restaurant-item-details">
        <h3>{{ restaurant.companyName || restaurant.displayName }}</h3>
        <p class="restaurant-address">{{ restaurant.streetAddress }}</p>
        <p class="restaurant-distance">{{ formatDistance(restaurant.distance) }} away</p>
        <div v-if="restaurant.hours" class="restaurant-hours">
          <img :src="clock" /><span>{{ restaurant.hours }}</span>
        </div>
      </div>

      <img :src="chevronRight" class="restaurant-details-expand" />
    </div>
  </div>
</template>

<script setup>
import chevronRight from '@/assets/icons/chevron-right-solid.svg';
import shopIcon from '@/assets/icons/shop-solid.svg';
import clock from '@/assets/icons/clock-regular.svg';

const props = defineProps({
  restaurants: { type: Array, default: () => [] }
});

defineEmits(['select']);

const formatDistance = d => (d < 1 ? `${Math.round(d * 1000)} m` : `${d.toFixed(1)} km`);
</script>

<style scoped lang="scss">
.restaurant-list {
  overflow-y: auto;
}

.restaurant-list-item {
  display: flex;
  padding: 16px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.restaurant-item-image {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 16px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .shop-placeholder-icon {
    width: 32px;
    height: 32px;
    object-fit: none;
  }
}

.restaurant-item-details {
  flex: 1;

  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
  }

  .restaurant-address, .restaurant-distance {
    font-size: 0.875rem;
  }

  .restaurant-distance {
    color: #0066cc;
    font-weight: 500;
  }

  .restaurant-hours {
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    color: #666;
    img {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
  }
}

.restaurant-details-expand {
  width: 16px;
  height: 16px;
  align-self: center;
}
</style>